var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6C7.25 3.37665 9.37665 1.25 12 1.25C14.6234 1.25 16.75 3.37665 16.75 6V7.56216C18.7215 9.01922 20 11.3603 20 14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14C4 11.3603 5.27847 9.01922 7.25 7.56216V6ZM12 2.75C10.2051 2.75 8.75 4.20507 8.75 6V6.68772C9.74308 6.24568 10.8428 6 12 6C13.1572 6 14.2569 6.24568 15.25 6.68772V6C15.25 4.20507 13.7949 2.75 12 2.75ZM12.75 14C12.75 13.5858 12.4142 13.25 12 13.25C11.5858 13.25 11.25 13.5858 11.25 14V18C11.25 18.4142 11.5858 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18V14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockAlt2);
export default __webpack_public_path__ + "static/media/lock-alt-2.f0f88714c45eb9d18736daac93fc4c54.svg";
export { ForwardRef as ReactComponent };